var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.bloks),function(blok,i){return _c(blok.component,_vm._b({key:(_vm.name + "-section-" + i),tag:"component"},'component',blok,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }